import { createMuiTheme } from "@material-ui/core/styles";
import defaultTheme from "@material-ui/core/styles/defaultTheme";
import palette from "../resource/palette";
import { DRAWER_WIDTH } from "../resource/constants";

export const theme = ({ background }) => ({
  overrides: {
    MuiPaper: {
      root: {
        backgroundColor: background.paperDefault
      }
    },
    MuiContainer: {
      root: {
        minWidth: "100%",

        [defaultTheme.breakpoints.up("lg")]: {
          padding: 0
        },

        [defaultTheme.breakpoints.up("sm")]: {
          padding: 0
        }
      }
    },

    MuiBox: {
      root: {
        [defaultTheme.breakpoints.up("sm")]: {
          width: `100%`
        },
        height: "100%"
      }
    },
    MuiDrawer: {
      paper: {
        [defaultTheme.breakpoints.up("sm")]: {
          width: 0
        },
        width: DRAWER_WIDTH,
        flexShrink: 0,
        background: background.default
      }
    },
    MuiInputBase: {
      input: {
        textAlign: "center"
      }
    },
    MuiTextField: {
      root: {
        width: "32rem",
        maxWidth: "100%"
      }
    }
  }
});

const getMuiTheme = SELECTED_COLOR_SCHEME =>
  createMuiTheme({
    palette: palette[SELECTED_COLOR_SCHEME],
    ...theme(palette[SELECTED_COLOR_SCHEME])
  });

export default getMuiTheme;
